// Module
var code = "<h2 id=\"ecommunications-center\">eCommunications Center</h2> <p>Representatives are available to answer your questions about AES.</p> ";
// Exports
export default code;